// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"84":"ce347339","97":"fb5da039","148":"9fb5b76d","218":"8d434491","233":"3cb54d52","240":"ec5df9b3","380":"8817dc24","478":"83c74b53","582":"550cb807","657":"f9cd4653","680":"d0cc8907","797":"50450239","866":"e0ed879d","908":"7cbd7b7a","973":"d89eec96","977":"04cf0e8a"}[chunkId] + ".chunk.js";
};